import { formatDateOnlyYmd, timesheetOverlapsDateRange } from "./dateOnly";
import { formatPickerDateYmd } from "./workCalendar";

export { timesheetOverlapsDateRange };

export const REPORT_DATE_RANGE_OPTIONS = [
  "All",
  "Today",
  "This Week",
  "Last Week",
  "This Month",
  "Last Month",
  "This Quarter",
  "Last Quarter",
  "This Year",
  "Last Year",
];

/** Default date-range preset for filters (current calendar year). */
export const DEFAULT_DATE_RANGE_PRESET = "This Year";

/** Timesheet pages keep showing all records until the user narrows the range. */
export const TIMESHEET_DATE_RANGE_PRESET = "All";

export function createDateFilterState(preset = DEFAULT_DATE_RANGE_PRESET) {
  if (!preset || preset === "All") {
    return { range: "All", start_date: null, end_date: null };
  }
  const { start_date, end_date } = getReportDateRange(preset);
  return { range: preset, start_date, end_date };
}

function formatDateYmd(date) {
  return formatDateOnlyYmd(date);
}

/** Same presets as Reports → date range filter. */
export function getReportDateRange(filter) {
  if (!filter || filter === "All") {
    return { start_date: null, end_date: null };
  }

  const todayYmd = formatPickerDateYmd(new Date());
  const todayParts = todayYmd ? todayYmd.split("-").map(Number) : null;
  const today = todayParts
    ? new Date(todayParts[0], todayParts[1] - 1, todayParts[2])
    : new Date();
  let startDate;
  let endDate;

  switch (filter) {
    case "Today":
      startDate = new Date(today);
      endDate = new Date(today);
      break;

    case "This Week":
      startDate = new Date(today);
      startDate.setDate(today.getDate() - today.getDay());
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6);
      break;

    case "Last Week":
      startDate = new Date(today);
      startDate.setDate(today.getDate() - today.getDay() - 7);
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6);
      break;

    case "This Month":
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      break;

    case "Last Month":
      startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      endDate = new Date(today.getFullYear(), today.getMonth(), 0);
      break;

    case "This Quarter": {
      const thisQuarterStartMonth = Math.floor(today.getMonth() / 3) * 3;
      startDate = new Date(today.getFullYear(), thisQuarterStartMonth, 1);
      endDate = new Date(today.getFullYear(), thisQuarterStartMonth + 3, 0);
      break;
    }

    case "Last Quarter": {
      let lastQuarterStartMonth = Math.floor(today.getMonth() / 3) * 3 - 3;
      let lastQuarterYear = today.getFullYear();
      if (lastQuarterStartMonth < 0) {
        lastQuarterStartMonth += 12;
        lastQuarterYear -= 1;
      }
      startDate = new Date(lastQuarterYear, lastQuarterStartMonth, 1);
      endDate = new Date(lastQuarterYear, lastQuarterStartMonth + 3, 0);
      break;
    }

    case "This Year":
      startDate = new Date(today.getFullYear(), 0, 1);
      endDate = new Date(today.getFullYear(), 11, 31);
      break;

    case "Last Year":
      startDate = new Date(today.getFullYear() - 1, 0, 1);
      endDate = new Date(today.getFullYear() - 1, 11, 31);
      break;

    default:
      return { start_date: null, end_date: null };
  }

  return {
    start_date: formatDateYmd(startDate),
    end_date: formatDateYmd(endDate),
  };
}
